export function decorateSocialMediaBox(data, typeName, timelineEntry) {
    var container = $(".timeline_entry." + typeName + "#" + timelineEntry.id);
    var content = $.parseJSON(data.content);
    if (typeof content == "object") {
        container.find(".content").prepend(content.html);
    } else {
        container.find(".content").prepend(data.content.html);
    }
    container.find(".js-spinner").hide();
}
